<template>
  <div class="assign-commitment-modal">
    <h-btn @click="display=true" flat color="info">New Commitment</h-btn>
    <modal v-if="display">
      <div slot="header">
        New Commitment
      </div>
      <div slot="body">
        <form @submit.prevent="save">
          <h-input label="Title" outline required v-model="commitment.title" />
          <v-textarea label="Description" outline multi-line required v-model="commitment.description" />
          <div class="outline">
            <label for="due_date">Due At</label>
            <input type="date" name="due_date" v-model="commitment.due_date" />
          </div>
          <h-btn color="primary" type="submit" flat>Save</h-btn>
          <h-btn @click="display=false" flat>Cancel</h-btn>
        </form>
      </div>
      <div slot="footer">
      </div>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal";
import moment from "moment";
import dataStore from "@/services/api/store";
import user from "@/services/api/authUser";
import snackbarHub from "@/services/hubs/snackbar";

export default {
  props: ["clientId"],
  components: {
    modal
  },
  data() {
    return {
      display: false,
      commitment: {
        due_date: moment().format("YYYY-MM-DD")
      }
    };
  },
  methods: {
    save() {
      let commitment = Object.assign(
        { client: this.clientId },
        this.commitment
      );
      commitment.due_date = moment(this.commitment.due_date).format();
      commitment.assigned_by = user.id;
      dataStore.create("CoachCommitments", commitment).then(c => {
        this.display = false;
        this.commitment = {
          due_date: moment().format("YYYY-MM-DD")
        };
        snackbarHub.update("Saved");
        this.$emit("saved", c);
      });
    }
  }
};
</script>

<style lang="less">
.assign-commitment-modal {
  .assign-commitment-modal .modal-container {
    width: 500px;
  }
  .outline {
    label {
      padding-right: 5px;
    }
  }
}
</style>
